import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  getClients,
  getWorkingRoutesNodes,
} from "../../../redux/api/expedition.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  ActiveExpeditionType,
  ActiveExpeditionView,
} from "../../../redux/interfaces/expedition.interface";
import {
  clearAwbHistory,
  clearBinHistory,
  clearWorkingRoutesNodes,
  setClientsSelectedActiveExpedition,
  setClientsSelectedActiveExpeditionForNode,
  setClientsSelectedActiveExpeditionForPickUpRoute,
} from "../../../redux/reducer/expedition.reducer";
import useActiveExpeditionType from "./useActiveExpeditionType";

function useActiveExpeditions() {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = useActiveExpeditionType();
  const view: ActiveExpeditionView =
    searchParams.get("view") === "bin" ? "bin" : "awb";
  const clientsNodesData = useAppSelector(
    (state) => state.expedition.workingRoutesNodes.data.data,
  );
  const [clientsNodes, setClientsNodes] = useState<typeof clientsNodesData>([]);

  const handleChangeView = (
    nextType: ActiveExpeditionType,
    nextView: ActiveExpeditionView,
  ) => {
    if (nextType === type && nextView === view) return;
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      next.set("type", nextType);
      next.set("view", nextView);
      next.set("page", "1");
      return next;
    });
  };

  useEffect(() => {
    const clearSelection = () => {
      dispatch(clearAwbHistory());
      dispatch(clearBinHistory());
      dispatch(setClientsSelectedActiveExpedition([]));
      dispatch(setClientsSelectedActiveExpeditionForNode([]));
      dispatch(setClientsSelectedActiveExpeditionForPickUpRoute([]));
    };
    clearSelection();
    return clearSelection;
  }, [dispatch, type, view]);

  useEffect(() => {
    dispatch(getWorkingRoutesNodes({ page: 1, perPage: 50 }));
    dispatch(getClients({ page: 1, perPage: 99999 }));
    return () => {
      dispatch(clearWorkingRoutesNodes());
    };
  }, [dispatch]);

  useEffect(() => {
    if (clientsNodesData.length && clientsNodes.length === 0) {
      setClientsNodes(clientsNodesData);
    }
  }, [clientsNodesData, clientsNodes]);

  return { type, view, clientsNodes, handleChangeView };
}

export default useActiveExpeditions;
